import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const { error: authError } = await supabase.auth.signInWithPassword({ email, password });

    if (authError) {
      setError("Invalid credentials. Please try again.");
    }
    // On success, ProtectedRoute's onAuthStateChange fires and renders the child automatically
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="w-full max-w-xs">
        {/* Mark */}
        <div className="flex flex-col items-center mb-10">
          <div className="w-8 h-8 rounded-full border border-border flex items-center justify-center mb-4">
            <Lock className="w-3.5 h-3.5 text-muted-foreground/60" />
          </div>
          <p className="font-sans text-[9px] uppercase tracking-[0.3em] text-muted-foreground/50">
            Studio Access
          </p>
          <div className="w-6 h-px bg-absa-red/40 mt-3" />
        </div>

        <form onSubmit={handleLogin} className="flex flex-col gap-4">
          <div className="flex flex-col gap-1.5">
            <label className="font-sans text-[9px] uppercase tracking-[0.2em] text-muted-foreground/60">
              Email
            </label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bg-background border border-border px-3 py-2.5 font-sans text-sm text-foreground placeholder:text-muted-foreground/30 focus:outline-none focus:border-absa-red/50 transition-colors"
              placeholder="you@example.com"
            />
          </div>

          <div className="flex flex-col gap-1.5">
            <label className="font-sans text-[9px] uppercase tracking-[0.2em] text-muted-foreground/60">
              Password
            </label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-background border border-border px-3 py-2.5 font-sans text-sm text-foreground placeholder:text-muted-foreground/30 focus:outline-none focus:border-absa-red/50 transition-colors"
              placeholder="••••••••"
            />
          </div>

          {error && (
            <p className="font-sans text-[9px] text-absa-red tracking-wide">{error}</p>
          )}

          <button
            type="submit"
            disabled={loading}
            className="mt-2 bg-foreground text-background font-sans text-[10px] uppercase tracking-[0.2em] px-4 py-3 hover:bg-absa-red hover:text-primary-foreground transition-colors disabled:opacity-40"
          >
            {loading ? "Signing in…" : "Enter Studio"}
          </button>
        </form>

        <p className="font-sans text-[8px] text-muted-foreground/25 text-center mt-8 uppercase tracking-widest">
          Restricted access
        </p>
      </div>
    </div>
  );
}
